import {
  IssueFragment,
  ObservationsV1IssueAutonomyLevel,
  ObservationsV1IssueFeedbackInput,
  ReviewIssueMutation,
  ReviewIssueMutationVariables,
  useReviewIssueMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useReviewIssue = withStandardMutationHook<
  ReviewIssueMutation,
  IssueFragment,
  ReviewIssueMutationVariables,
  'reviewIssue',
  [string, ObservationsV1IssueFeedbackInput[], ObservationsV1IssueAutonomyLevel]
>(useReviewIssueMutation, 'reviewIssue', (name, feedback, autonomyLevel) => ({
  name,
  feedback,
  autonomyLevel,
}));
